













































































































































































































import Component, { mixins } from 'vue-class-component';
import { loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IPaginate } from '@/types/types';
import { IManagedEvent, IEventRecipient } from '@/store/modules/events-management';
import timestamp from '@/filters/timestamp';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import qs from 'qs';

const eventsManagementModule = namespace('eventsManagement');

@Component({
  name: 'EventsManagement',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    EmptyPage: loadWidget('pages/EmptyPage'),
  },
  filters: {
    timestamp,
  },
})
export default class EventsManagement extends mixins(WidgetMixins) {
  @eventsManagementModule.Getter('getAllEvents') events!: IManagedEvent[];
  @eventsManagementModule.Getter('getPagination') pagination!: IPaginate;
  @eventsManagementModule.Getter('getRecipients') recipients!: IEventRecipient[];
  @eventsManagementModule.Getter('getRecipientsPagination') recipientsPagination!: IPaginate;

  options: any = {};
  query: string = '';
  states: string[] = ['ALL', 'SCHEDULED', 'STARTED', 'COMPLETED', 'FAILED'];
  state: string = 'ALL';
  searchTerm: string = '';

  recipientsDialog: boolean = false;
  recipientOptions: any = {};
  recipientStatuses: string[] = ['ALL', 'PENDING', 'QUEUED', 'SENT', 'FAILED'];
  recipientStatus: string = 'ALL';

  requeueDialog: boolean = false;
  resetSentRecipients: boolean = false;
  activeEvent: IManagedEvent | null = null;

  headers: Array<{ text: string; value: string; sortable?: boolean }> = [
    { text: 'ID', value: 'id', sortable: false },
    { text: 'Name', value: 'name', sortable: false },
    { text: 'Sender', value: 'senderAddress', sortable: false },
    { text: 'Customer', value: 'userName', sortable: false },
    { text: 'State', value: 'state', sortable: false },
    { text: 'Attempts', value: 'dispatchAttempts', sortable: false },
    { text: 'Recipients', value: 'recipientCounts', sortable: false },
    { text: 'Execution Time', value: 'executionTimestamp', sortable: false },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  recipientHeaders: Array<{ text: string; value: string; sortable?: boolean }> = [
    { text: 'Phone', value: 'phone', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Attempts', value: 'attempts', sortable: false },
    { text: 'Last Error', value: 'lastError', sortable: false },
  ];

  get isDialogLoading(): boolean {
    return this.$store.getters['getIsDialogLoading'];
  }

  stateClass(state: string): string {
    const normalized = (state || '').toLowerCase();
    if (['completed', 'sent', 'delivered'].includes(normalized)) return 'ka-status--success';
    if (['failed'].includes(normalized)) return 'ka-status--error';
    if (['scheduled', 'pending'].includes(normalized)) return 'ka-status--info';
    return 'ka-status--warning';
  }

  truncateText(value: string, length: number): string {
    if (!value) return '—';
    return value.length > length ? `${value.slice(0, length)}…` : value;
  }

  buildQuery(overrides: any = {}): string {
    const params: any = {
      page: this.pagination.page,
      size: this.pagination.itemsPerPage,
      ...(this.state !== 'ALL' && { state: this.state }),
      ...(this.searchTerm && { searchTerm: this.searchTerm }),
      ...overrides,
    };
    return qs.stringify(params, { skipNulls: true, addQueryPrefix: true });
  }

  fetchEvents(): void {
    this.query = this.buildQuery();
    this.$store.dispatch('eventsManagement/list', this.query);
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.fetchEvents();
  }

  openRecipients(event: IManagedEvent): void {
    this.activeEvent = event;
    this.recipientStatus = 'ALL';
    this.recipientsDialog = true;
    this.fetchRecipients(1, 15);
  }

  fetchRecipients(page: number, size: number): void {
    if (!this.activeEvent) return;
    const query = qs.stringify(
      {
        page,
        size,
        ...(this.recipientStatus !== 'ALL' && { status: this.recipientStatus }),
      },
      { skipNulls: true, addQueryPrefix: true },
    );
    this.$store.dispatch('eventsManagement/recipients', { eventId: this.activeEvent.id, query });
  }

  openRequeue(event: IManagedEvent): void {
    this.activeEvent = event;
    this.resetSentRecipients = false;
    this.requeueDialog = true;
  }

  confirmRequeue(): void {
    if (!this.activeEvent) return;
    this.$store.dispatch('eventsManagement/requeue', {
      eventId: this.activeEvent.id,
      resetSentRecipients: this.resetSentRecipients,
      query: this.query,
    });
    this.requeueDialog = false;
  }

  @Watch('state')
  onStateChange(): void {
    this.fetchEvents();
  }

  @Watch('options', { deep: true })
  onOptionsChange(paginate: IPaginate): void {
    const query = this.buildQuery({ page: paginate.page, size: paginate.itemsPerPage });
    if (query === this.query) return;
    this.query = query;
    this.fetchEvents();
  }

  @Watch('recipientOptions', { deep: true })
  onRecipientOptionsChange(paginate: IPaginate): void {
    if (!this.recipientsDialog) return;
    this.fetchRecipients(paginate.page, paginate.itemsPerPage);
  }

  @Watch('recipientStatus')
  onRecipientStatusChange(): void {
    if (!this.recipientsDialog) return;
    this.fetchRecipients(1, this.recipientsPagination.itemsPerPage || 15);
  }

  created(): void {
    this.$store.dispatch('auth/me');
    this.fetchEvents();
  }
}
